import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import PopularDestinations from '../components/PopularDestinations';
import WhyChooseUs from '../components/WhyChooseUs';
import AboutSection from '../components/AboutSection';
import CategoryFilter from '../components/CategoryFilter';
import PackageCard from '../components/PackageCard';
import BookingForm from '../components/BookingForm';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import { usePackages } from '../context/PackageContext';
import '../styles/Home.css';

const Home = () => {
  const { getFilteredPackages } = usePackages();
  const filteredPackages = getFilteredPackages();

  return (
    <div className="home-modern">
      <Header />
      <HeroSection />
      
      {/* Popular Destinations Carousel */}
      <PopularDestinations />

      {/* What We Offer Section */}
      <WhyChooseUs />

      {/* About Section */}
      <AboutSection />
      
      {/* Organized Trips Section */}
      <section className="organized-trips" id="packages">
        <div className="container">
          <div className="section-header-modern">
            <h2 className="section-title-main">Organized Trips</h2>
            <p className="section-subtitle-modern">
              Discover our carefully curated travel packages across amazing destinations
            </p>
          </div>

          <CategoryFilter />

          <div className="packages-grid-modern">
            {filteredPackages.length > 0 ? (
              filteredPackages.map((pkg) => (
                <PackageCard key={pkg.id} package={pkg} />
              ))
            ) : (
              <p className="no-packages">No packages available in this category.</p>
            )}
          </div>
        </div>
      </section>

      {/* Booking Form Section */}
      <section className="booking-section">
        <div className="container">
          <div className="section-header-modern">
            <h2 className="section-title-main">Ready to Start Your Journey?</h2>
            <p className="section-subtitle-modern">
              Fill out the form below and we'll help you plan your perfect trip
            </p>
          </div>
          <BookingForm tripTitle="Your Dream Trip" />
        </div>
      </section>

      {/* FAQ Section */}
      <FAQ />

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <div className="testimonial-card">
            <div className="quote-mark">"</div>
            <h2 className="testimonial-title">An Unforgettable Experience! Everything Was Perfect</h2>
            <p className="testimonial-text">
              From start to finish, the entire trip was flawlessly organized. The destinations were breathtaking, 
              the accommodations were top-notch, and our guide was incredibly knowledgeable. Every detail was 
              taken care of, allowing us to simply enjoy the journey. I highly recommend AiryouGo to anyone 
              looking for a stress-free and memorable travel experience!
            </p>
            <div className="testimonial-author">
              <div className="author-info">
                <h4>Sarah Johnson</h4>
                <p>Traveled to Japan - Cherry Blossom Tour</p>
              </div>
              <div className="testimonial-rating">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
